import { forwardRef, Provider, Type } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

export const provideValidator = (valueAccessor: () => Type<unknown>): Provider => ({
  provide: NG_VALIDATORS,
  useExisting: forwardRef(valueAccessor),
  multi: true,
});
